export const BAND = {
  cold: "#94A3AD",
  warm: "#3E8F99",
  hot: "#E2711D",
  priority: "#B23A2E",
};

export const BAND_TEXT = {
  cold: "#1C2530",
  warm: "#FFFFFF",
  hot: "#FFFFFF",
  priority: "#FFFFFF",
};

export const STAGES = [
  "Suspect", "Researched", "Contacted", "Engaged", "Qualified",
  "Meeting Booked", "Handoff", "Rep-Owned Deal", "Close-out",
];

export const STATUS_LABEL = {
  open: "Open", won: "Won", lost: "Lost",
  disqualified: "Disqualified", dnc: "Opted-out / DNC", nurture: "Nurture",
};

export const ROLE_LABEL = {
  admin: "Admin", supervisor: "Sales Lead", rep: "Rep",
};

export const VENDOR_CATEGORIES = ["Software", "Talent/Staffing", "Trainer", "Training Vendor", "Other"];
export const VENDOR_DOMAIN_CATEGORIES = ["Trainer", "Training Vendor"];

export function bandOf(score) {
  if (score >= 80) return "priority";
  if (score >= 60) return "hot";
  if (score >= 30) return "warm";
  return "cold";
}
